import { useEffect, useState, useCallback } from 'react'
import { apiGet } from '../api'

interface MsAccount {
  label: string
  email: string | null
  display_name: string | null
  last_sync_at: number | null
  last_error: string | null
}

const API_BASE = (import.meta.env.VITE_API_BASE as string) ?? ''

function fmtAge(ts: number | null | undefined): string {
  if (!ts) return 'never synced'
  const s = Math.floor((Date.now() - ts) / 1000)
  if (s < 60)    return `${s}s ago`
  if (s < 3600)  return `${Math.floor(s/60)}m ago`
  if (s < 86400) return `${Math.floor(s/3600)}h ago`
  return `${Math.floor(s/86400)}d ago`
}

const PRESET_LABELS = ['mastercopy', 'gameonsolutions']

export default function MailboxConnect() {
  const [accounts, setAccounts] = useState<MsAccount[] | null>(null)

  const load = useCallback(async () => {
    try {
      const res = await apiGet<{ accounts: MsAccount[] }>('/auth/microsoft/accounts')
      setAccounts(res.accounts)
    } catch { setAccounts([]) }
  }, [])

  useEffect(() => { load() }, [load])

  if (accounts === null) return null

  const connected = new Set(accounts.map(a => a.label))
  const missing = PRESET_LABELS.filter(l => !connected.has(l))

  return (
    <div className="mailbox-connect">
      <span className="mono" style={{ color: 'var(--text-secondary)', letterSpacing: '0.12em', textTransform: 'uppercase', fontSize: '0.62rem' }}>
        Office 365
      </span>
      {accounts.map(a => (
        <span key={a.label} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          <span className="acct-chip" title={a.email ?? ''}>
            ✓ {a.label} · {fmtAge(a.last_sync_at)}
          </span>
          <a href={`${API_BASE}/auth/microsoft/init?label=${a.label}`}
             title="Re-grant scopes (use after adding new permissions)"
             style={{ fontSize: '0.65rem', padding: '3px 8px', borderRadius: 999,
                      border: '1px solid var(--border-soft)', color: 'var(--text-muted)',
                      textDecoration: 'none', fontFamily: 'var(--font-mono)',
                      letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            re-consent
          </a>
        </span>
      ))}
      {missing.map(l => (
        <a key={l} href={`${API_BASE}/auth/microsoft/init?label=${l}`} className="btn-connect">
          + connect {l}
        </a>
      ))}
    </div>
  )
}
